export enum APP_VARIANT {
  BANQUET_FIRST = "BANQUET_FIRST",
  LANDMARK = "LANDMARK",
  TALKVIT = "TALKVIT",
}